import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Survey Search', path: '/survey-search' },
    { name: 'Property Hub', path: '/property-hub' },
    { name: 'Fee Scale', path: '/fee-scale' },
    { name: 'Consultation', path: '/consultation' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <footer className="bg-stone-900 text-stone-300">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_geopick-survey/artifacts/jqqgmzvv_IMG_3434.jpeg"
              alt="Versatile Geopick NIG Ltd"
              className="h-14 w-auto mb-6 bg-white rounded p-1"
              style={{ filter: 'sepia(20%) saturate(80%) hue-rotate(-20deg)' }}
            />
            <p className="text-stone-400 leading-relaxed mb-6 max-w-md">
              Professional land surveying and property verification services across Nigeria.
            </p>
            <div className="flex items-center gap-2 text-sm">
              <span className="px-3 py-1 bg-emerald-900/30 text-emerald-300 rounded-full">RC-2001517</span>
              <span className="text-stone-500">|</span>
              <span className="text-stone-400">Licensed & Certified</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-sm font-semibold tracking-wider uppercase mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-stone-400 hover:text-emerald-400 transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white text-sm font-semibold tracking-wider uppercase mb-6">Contact</h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:+2348034494507" 
                  className="flex items-start gap-3 text-stone-400 hover:text-emerald-400 transition-colors duration-300 group"
                >
                  <Phone className="h-4 w-4 text-emerald-500 flex-shrink-0 mt-0.5" />
                  <span className="text-sm">+234 803 449 4507</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:Versatilegeopick@gmail.com" 
                  className="flex items-start gap-3 text-stone-400 hover:text-emerald-400 transition-colors duration-300 group"
                >
                  <Mail className="h-4 w-4 text-emerald-500 flex-shrink-0 mt-0.5" />
                  <span className="text-sm break-all">Versatilegeopick@gmail.com</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3">
                  <MapPin className="h-4 w-4 text-emerald-500 flex-shrink-0 mt-0.5" />
                  <p className="text-stone-400 text-sm">
                    3 Silverlake, off Tonia Emmanuel Road, Ogombo, Lagos
                  </p>
                </div>
              </li>
              <li>
                <a 
                  href="https://instagram.com/versatilegeopick"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-stone-400 hover:text-emerald-400 transition-colors duration-300 group"
                >
                  <Instagram className="h-4 w-4 text-emerald-500 flex-shrink-0 mt-0.5" />
                  <span className="text-sm">@versatilegeopick</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
            <p className="text-stone-500">
              © {currentYear} Versatile Geopick NIG Ltd. All rights reserved.
            </p>
            <p className="text-stone-600 text-xs">
              Precision. Compliance. Confidence.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
